import { useEffect } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { useRequestTypesForPracticeService } from '@atlassian/jira-servicedesk-request-types-config-common/src/services/request-types-for-practice';

const useAffectedRequestTypes = (practice: string) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const { data: projectContext } = useProjectContext();
	const { projectId } = projectContext || {};

	const {
		data: affectedRequestTypes,
		loading,
		error,
		fetch,
	} = useRequestTypesForPracticeService(projectId as number, practice); // eslint-disable-line @typescript-eslint/consistent-type-assertions

	useEffect(() => {
		if (affectedRequestTypes) {
			fireTrackAnalytics(createAnalyticsEvent({}), 'affectedRequestTypes fetched');
		}
	}, [createAnalyticsEvent, affectedRequestTypes]);

	useEffect(() => {
		if (error) {
			fireErrorAnalytics({
				meta: {
					id: 'affectedRequestTypesFetch',
					packageName: 'jiraServicedeskItsmFeatures',
				},
				error,
				event: createAnalyticsEvent({}),
				sendToPrivacyUnsafeSplunk: true,
			});
		}
	});

	return {
		data: { numAffectedRequestTypes: affectedRequestTypes?.length },
		loading,
		error,
		fetch,
	};
};

export default useAffectedRequestTypes;
